import { tv } from 'tailwind-variants'

export const inventoryButtonVariants = tv({
  base: 'floating-action-btn btn-inventory',
  variants: {
    isActive: {
      true: 'active',
      false: ''
    },
    variant: {
      default: '',
      right: 'left'
    }
  },
  defaultVariants: {
    isActive: false,
    variant: 'default'
  }
})